/**
 * withBeautyAssistantSession
 * HOC for wrapping the provided component with BeautyAssistantSessionProvider
 */

import React from 'react'

import BeautyAssistantSessionProvider from './beauty-assistant-sessions-provider'

export default function withBeautyAssistantSession (WrappedComponent) {
  return function BeautyAssistantSessionProviderHOC(props) {
    return (
      <BeautyAssistantSessionProvider>
        <WrappedComponent {...props} />
      </BeautyAssistantSessionProvider>
    )
  }
}
